var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeeMoreIconDesktop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.19417 0.624268C3.59656 0.624268 0.676758 3.54407 0.676758 7.14168C0.676758 10.7393 3.59656 13.6591 7.19417 13.6591C10.7918 13.6591 13.7116 10.7393 13.7116 7.14168C13.7116 3.54407 10.7918 0.624268 7.19417 0.624268ZM7.19417 12.3556C4.31999 12.3556 1.98024 10.0159 1.98024 7.14168C1.98024 4.2675 4.31999 1.92775 7.19417 1.92775C10.0683 1.92775 12.4081 4.2675 12.4081 7.14168C12.4081 10.0159 10.0683 12.3556 7.19417 12.3556ZM7.19417 9.0969L9.80114 6.48994H4.58721L7.19417 9.0969Z",
    fill: "rgba(255, 255, 255, 0.4)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeeMoreIconDesktop);
export default __webpack_public_path__ + "static/media/seeMoreIconDesktop.2411ba25.svg";
export { ForwardRef as ReactComponent };